import Feedbacks from './Feedbacks';
import { IFeedback } from './interfaces';

export type { IFeedback };
export default Feedbacks;
